import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import LevelAndUserButton from './LevelAndUserButton.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle  } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faCog } from '@fortawesome/free-solid-svg-icons';

// MainMenu component displays the main menu with options to create a new cup, view events, stats, players, and settings.
function MainMenu() {
  const navigate = useNavigate();
  const { user } = useUser();

  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  useEffect(() => {
    const addUserToDatabase = async () => {
      if (user) {
        try {
          const response = await fetch('/server/crazy-cup-server/addOrCheckUser.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              userId: user.id,
              username: user.username || user.emailAddresses[0].emailAddress,
              email: user.emailAddresses[0].emailAddress,
              profilePic: user.imageUrl,
            }),
          });

          const result = await response.json();
          if (result.success) {
          } else {
            console.error('Error adding user:', result.message);
          }
        } catch (error) {
          console.error('Error connecting to the server:', error);
        }
      }
    };

    const checkAndSetDefaultStats = async () => {
      if (user) {
        try {
          const response = await fetch('/server/crazy-cup-server/checkAndSetDefaultStats.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              userId: user.id,
            }),
          });
    
          const result = await response.json();
          if (result.success) {
          } else {
            console.error('Error checking/updating stats:', result.message);
          }
        } catch (error) {
          console.error('Error connecting to the server:', error);
        }
      }
    };

    const initializeUser = async () => {
      await addUserToDatabase();
      await checkAndSetDefaultStats();
    
      
      const storedUserId = localStorage.getItem('userId');
      if (!storedUserId) {
        localStorage.setItem('userId', user.id);
      }
    };

    initializeUser();
  }, [user]);

  return (
    <div id="main-page" className="page">
      <div id="main-menu" className="menu-container">
        <div className="menu-card" onClick={() => navigate('/create-new-cup')}>
          <FontAwesomeIcon icon={faPlusCircle} className="menu-icon" />
          <h2>Create New Cup</h2>
          <p>Start a new event for players to join.</p>
        </div>
        <div className="menu-card" onClick={() => navigate('/current-events')}>
          <FontAwesomeIcon icon={faCalendarAlt} className="menu-icon" />
          <h2>Events</h2>
          <p>View upcoming and completed events.</p>
        </div>
        <div className="menu-card" onClick={() => navigate('/my-stats')}>
          <FontAwesomeIcon icon={faTrophy} className="menu-icon" /> 
          <h2>My Stats</h2>
          <p>Track your statistics and progress.</p>
        </div>
        <div className="menu-card" onClick={() => navigate('/players')}>
          <FontAwesomeIcon icon={faUsers} className="menu-icon" />
          <h2>Players</h2>
          <p>View and compare statistics with other players.</p>
        </div>
        <div className="menu-card" onClick={() => navigate('/settings')}>
          <FontAwesomeIcon icon={faCog} className="menu-icon" />
          <h2>Settings</h2>
          <p>Adjust your preferences and account settings.</p>
      </div>
      </div>
    </div>
  );

}

export default MainMenu;